module.exports = __webpack_public_path__ + "static/media/banner-image3.609303d7.png";